
/* NIR.Systems product-page bridge — standalone Plumbline behavior stays intact. */
(function(){
  var originalTitle=null, originalSub=null;
  function currentRoute(){
    var h=location.hash||"#/dashboard";
    if(h.charAt(0)==="#") h=h.slice(1);
    if(h.charAt(0)==="/") h=h.slice(1);
    var q=h.indexOf("?"); if(q>=0) h=h.slice(0,q);
    return h||"dashboard";
  }
  function emit(){
    try{ parent.postMessage({nir:1,type:"view",view:currentRoute()},"*"); }catch(e){}
  }
  function applyBrand(d){
    var brand=document.querySelector(".brand b"), sub=document.querySelector(".brand span");
    if(brand && originalTitle===null) originalTitle=brand.textContent;
    if(sub && originalSub===null) originalSub=sub.textContent;
    if(brand) brand.textContent=d.name||originalTitle||"PLUMBLINE";
    if(sub) sub.textContent=d.name ? "SITE OS · "+String(d.name).toUpperCase() : (originalSub||"SITE OS · KEYSTONE & CO.");
    if(d.color) document.documentElement.style.setProperty("--hv",d.color);
    else document.documentElement.style.removeProperty("--hv");
  }
  addEventListener("message",function(e){
    var d=e.data||{}; if(!d.nir) return;
    if(d.type==="goto" && d.view){
      var h="#/"+d.view;
      if(location.hash===h){ try{ if(typeof render==="function") render(); }catch(x){} emit(); }
      else location.hash=h;
    }
    if(d.type==="brand") applyBrand(d);
    if(d.type==="cycle" && d.on && !location.hash) location.hash="#/dashboard";
  });
  addEventListener("hashchange",emit);
  addEventListener("load",emit);
})();
